<template>
  <div>
    <h2>
      Neugierig geworden? Lust zum Mitmachen?
    </h2>
    <div>
      Hier geht es direkt zur Smartphone-App des Projekts LinguaSnappHamburg
      in den App-Stores der Universität Hamburg zum kostenlosen Download:
    </div>
    <div class="flex justify-center my-5">
      <a
        class="badge play-store"
        href="https://play.google.com/store/apps/details?id=de.uni_hamburg.linguasnapp"
        target="_blank"
      >
        <img
          src="../../assets/images/badges/de_badge_play_store.png"
          alt="Google Play Store"
        />
      </a>
      <a
        class="badge app-store"
        href="https://apps.apple.com/de/app/linguasnapphamburg/id1445539231"
        target="_blank"
      >
        <img
          src="../../assets/images/badges/de_badge_app_store.svg"
          alt="Apple App Store"
        />
      </a>
    </div>
    <div>
      Hier findet man die
      <a href="https://www.linguasnapp.uni-hamburg.de/projekt/app.html#10414840">
        Datenschutzerklärung
      </a>
      sowie
      <a href="https://www.linguasnapp.uni-hamburg.de/projekt/anleitungen.html">
        Anleitungen zum Gebrauch der App.
      </a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'LinkToStore',
};
</script>

<style scoped>
.badge {
  @apply h-16 m-5;
}

.badge img {
  @apply h-full;
}
</style>
